var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBrandingExperience(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Grupo_568",
    "data-name": "Grupo 568",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 351.728,
    height: 31.521,
    viewBox: "0 0 351.728 31.521",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_58",
    "data-name": "Rect\\xE1ngulo 58",
    width: 351.728,
    height: 31.522,
    fill: "none"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Grupo_557",
    "data-name": "Grupo 557",
    transform: "translate(0 0)",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_489",
    "data-name": "Trazado 489",
    d: "M4.853,1.133H.039L0,17.979c-.01,3.618,2.282,5.6,5.4,5.613a17.607,17.607,0,0,0,3.827-.665V19.888A13.131,13.131,0,0,1,6.541,19.7a2.222,2.222,0,0,1-1.724-2.528l.015-6.939,4.626.011L9.466,6.88,4.842,6.868Z",
    transform: "translate(0 0.299)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_490",
    "data-name": "Trazado 490",
    d: "M250.757,1.133h-4.814L245.9,17.979c-.01,3.618,2.282,5.6,5.4,5.613a17.607,17.607,0,0,0,3.827-.665V19.888s-2.034-.139-2.683-.186c-1.068-.078-1.729-.924-1.724-2.528l.015-6.939,4.626.011.009-3.366-4.624-.011Z",
    transform: "translate(64.957 0.299)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_491",
    "data-name": "Trazado 491",
    d: "M21.479,6.319c-2.643.027-4.221.343-5.859,1.69l.024-6.876H10.8l-.059,22.2h4.846l.021-8.25c.005-2.487,1.489-4.308,3.911-4.332a3.142,3.142,0,0,1,3.326,3.469l-.023,9.113h4.846l.027-10.516c.01-3.964-2.406-6.488-6.213-6.5",
    transform: "translate(2.837 0.299)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_492",
    "data-name": "Trazado 492",
    d: "M35.611,5.231c-5.317.016-8.691,3.532-8.7,8.629-.013,5.16,3.6,8.629,8.975,8.643A9.594,9.594,0,0,0,43.5,19.062l-2.762-2.523a6.02,6.02,0,0,1-4.505,2.19,4.235,4.235,0,0,1-4.02-2.621l11.712-3.054c-.177-4.844-3.409-7.843-8.318-7.823m-3.858,7.981c.166-2.863,1.71-4.4,4.1-4.4a3.219,3.219,0,0,1,3.329,2.4Z",
    transform: "translate(7.107 1.382)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_493",
    "data-name": "Trazado 493",
    d: "M59.214,11.593A4.9,4.9,0,0,0,63.055,6.73c.009-3.418-3.023-5.546-7.9-5.558l-10.19-.027-.057,22.181H55.45c5.126.014,8.36-2.32,8.369-6.117a5.409,5.409,0,0,0-4.605-5.615M49.958,5.24l4.938.013c1.9-.025,3.035.863,3.031,2.383,0,1.55-1.147,2.465-3.044,2.461l-4.937-.013Zm4.9,14-4.937-.013.014-5.254,4.937.011c2.341-.024,3.795.961,3.791,2.574-.005,1.709-1.464,2.688-3.805,2.681",
    transform: "translate(11.863 0.302)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_494",
    "data-name": "Trazado 494",
    d: "M68.064,5.269,63.22,5.257,63.177,22.29h4.844l.02-8.242c.008-2.863,2.153-4.714,5.613-4.389l.011-4.564c-2.518.025-4.215.343-5.609,1.838Z",
    transform: "translate(16.688 1.346)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_495",
    "data-name": "Trazado 495",
    d: "M240.155,5.269l-4.844-.013-.043,17.033h4.844l.02-8.242c.008-2.863,2.153-4.714,5.613-4.389l.011-4.564c-2.518.025-4.215.343-5.609,1.838Z",
    transform: "translate(62.147 1.346)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_496",
    "data-name": "Trazado 496",
    d: "M86.345,6.932c-1.592-1.341-3.1-1.7-5.491-1.705-4.719.02-7.819,3.3-7.83,8.431-.014,5.222,3.153,8.841,7.967,8.854,2.3.006,4.124-.509,5.323-2.173l-.005,1.918h4.814l.043-17.026-4.814-.013Zm-.935,9.549a4.113,4.113,0,0,1-3.437,2.013c-2.664-.008-4.433-1.93-4.46-4.7A4.424,4.424,0,0,1,82,9.118a4.1,4.1,0,0,1,3.787,2.339,5.188,5.188,0,0,1-.377,5.025",
    transform: "translate(19.289 1.378)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_497",
    "data-name": "Trazado 497",
    d: "M102.409,5.17a9.12,9.12,0,0,0-5.861,1.755l.008-1.67-4.844-.013-.043,17.029h4.844l.021-8.337c.005-2.487,1.459-4.308,3.881-4.332a3.143,3.143,0,0,1,3.326,3.469l-.024,9.2h4.846l.028-10.6c.009-3.964-2.411-6.321-6.182-6.5",
    transform: "translate(24.215 1.363)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_498",
    "data-name": "Trazado 498",
    d: "M145.522,5.17a9.12,9.12,0,0,0-5.861,1.755l.008-1.67-4.844-.013-.043,17.029h4.844l.021-8.337c.005-2.487,1.459-4.308,3.881-4.332a3.143,3.143,0,0,1,3.326,3.469l-.024,9.2h4.845l.028-10.6c.009-3.964-2.411-6.321-6.182-6.5",
    transform: "translate(35.603 1.363)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_499",
    "data-name": "Trazado 499",
    d: "M121.19,7.963a7.923,7.923,0,0,0-5.467-1.684c-4.719-.013-7.873,3.409-7.886,8.57-.014,5.222,3.153,8.721,7.968,8.734a6.456,6.456,0,0,0,5.355-2.155l-.006,1.908h4.814l.059-22.181-4.814-.014ZM116.947,19.6c-2.549-.008-4.24-1.93-4.267-4.7.039-2.737,1.774-4.685,4.292-4.677,2.484.006,4.211,1.929,4.2,4.7s-1.743,4.684-4.229,4.677",
    transform: "translate(28.486 0.301)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_500",
    "data-name": "Trazado 500",
    d: "M129.082,4.842a2.421,2.421,0,1,0-2.421-2.421,2.42,2.42,0,0,0,2.421,2.421",
    transform: "translate(33.458 0)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_501",
    "data-name": "Trazado 501",
    d: "M126.632,22.258h4.844l.043-17.029-4.844-.013Z",
    transform: "translate(33.45 1.378)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_502",
    "data-name": "Trazado 502",
    d: "M164.386,6.907c-1.722-1.442-3.1-1.661-5.55-1.632-4.584-.013-7.735,3.426-7.749,8.512-.014,5.221,3.189,8.71,7.84,8.721a6.57,6.57,0,0,0,5.428-2.138l-.005,1.583c-.006,2.444-1.884,4.012-4.829,4a9.525,9.525,0,0,1-5.585-1.822l-1.915,3.609a13.984,13.984,0,0,0,7.825,2.4c5.754.014,9.611-3.221,9.625-8.341l.042-16.565-5.12-.015ZM160.143,18.6c-2.545-.006-4.212-1.919-4.24-4.663.042-2.743,1.755-4.68,4.264-4.674s4.212,1.918,4.2,4.7c-.006,2.744-1.719,4.648-4.227,4.642",
    transform: "translate(39.91 1.379)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_503",
    "data-name": "Trazado 503",
    d: "M174.831,14.249l10.656.028.01-4.143-10.656-.027.013-4.808,11.857.032.011-4.186H169.811V23.332h17.2l.01-4.15-12.205-.03Z",
    transform: "translate(44.856 0.303)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_504",
    "data-name": "Trazado 504",
    d: "M203.056,5.23h-5.3l-3.335,5.164-3.1-5.164h-5.552l5.436,8.3-5.89,8.715h5.364l3.743-5.576,3.385,5.576h5.584l-5.751-8.715Z",
    transform: "translate(48.952 1.382)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_505",
    "data-name": "Trazado 505",
    d: "M212.625,5.241a8.222,8.222,0,0,0-5.354,1.675l.005-1.681-4.845-.013-.058,24.541,4.845.013.022-9.388a7.122,7.122,0,0,0,5.436,2.125c4.751.013,7.874-3.409,7.887-8.537.014-5.222-3.187-8.723-7.938-8.735M211.46,18.484c-2.485-.008-4.211-1.9-4.2-4.7.006-2.737,1.742-4.652,4.227-4.646s4.178,1.961,4.172,4.667c-.008,2.767-1.71,4.684-4.2,4.677",
    transform: "translate(53.458 1.379)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_506",
    "data-name": "Trazado 506",
    d: "M227.482,5.243c-5.317.016-8.691,3.532-8.7,8.629-.013,5.16,3.6,8.629,8.975,8.644a9.6,9.6,0,0,0,7.623-3.441l-2.762-2.525a6.02,6.02,0,0,1-4.505,2.19,4.235,4.235,0,0,1-4.02-2.621L235.8,13.066c-.177-4.844-3.409-7.843-8.318-7.823m-3.858,7.981c.166-2.863,1.71-4.4,4.1-4.4a3.219,3.219,0,0,1,3.329,2.4Z",
    transform: "translate(57.791 1.385)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_507",
    "data-name": "Trazado 507",
    d: "M260.464,10c0-.88.82-1.255,1.954-1.253a11.455,11.455,0,0,1,5.155,1.648l1.676-3.3a12.635,12.635,0,0,0-6.6-1.905c-3.683-.009-6.676,1.777-6.685,5.268-.015,5.947,8.766,4.523,8.758,7.228,0,.913-.914,1.32-2.14,1.316a10.194,10.194,0,0,1-5.88-2.124l-1.581,3.269a11.822,11.822,0,0,0,7.325,2.378c3.839.01,6.895-1.808,6.9-5.268.047-5.976-8.891-4.71-8.884-7.259",
    transform: "translate(67.391 1.371)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_508",
    "data-name": "Trazado 508",
    d: "M275.573,11.647a4.586,4.586,0,1,0,4.576,4.61,4.511,4.511,0,0,0-4.576-4.61m-.02,8.283a3.707,3.707,0,1,1,3.68-3.675,3.636,3.636,0,0,1-3.68,3.675",
    transform: "translate(71.579 3.077)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_509",
    "data-name": "Trazado 509",
    d: "M276.956,14.913c0-.847-.688-1.4-1.718-1.4l-1.951-.005-.01,4.211.918,0,0-1.35h.686l1.186,1.354,1.1,0-1.3-1.446a1.418,1.418,0,0,0,1.086-1.369m-1.727.635-1.03,0,0-1.211,1.029,0c.478,0,.8.231.8.6s-.321.617-.8.616",
    transform: "translate(72.187 3.568)",
    fill: "#fff"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBrandingExperience);
export default __webpack_public_path__ + "static/media/brandingExperience.88ecdb8fd5e4a2307bb0c48ad2acbc4d.svg";
export { ForwardRef as ReactComponent };